import { action, makeObservable, observable, toJS } from "mobx";
import { privatePost } from "../utils/NetworkService";
import { getSessionJson, setSessionJson, ChangeDecomalPoint } from '../utils/SessionService';
import { debug } from "../utils/UtilConsole";


class MissionPmgState {
    id;
    game;
    condition_count;
    reward_count;
    is_enabled;
    is_clear;
    play_count;
    mission_level;

    constructor(memberData) {
        this.id = memberData?.id ?? null;
        this.game = memberData?.game ?? null;
        this.condition_count = memberData?.condition_count ?? null;
        this.reward_count = memberData?.reward_count ?? null;
        this.is_enabled = memberData?.is_enabled ?? null;
        this.is_clear = memberData?.is_clear ?? null;
        this.play_count = memberData?.play_count ?? null;
        this.mission_level = memberData?.mission_level ?? null;
    }
}

class MissionCagState {
    id;
    game;
    condition_count;
    reward_count;
    is_enabled;
    is_clear;
    play_count;
    mission_level;
    constructor(memberData) {
        this.id = memberData?.id ?? null;
        this.game = memberData?.game ?? null;
        this.condition_count = memberData?.condition_count ?? null;
        this.reward_count = memberData?.reward_count ?? null;
        this.is_enabled = memberData?.is_enabled ?? null;
        this.is_clear = memberData?.is_clear ?? null;
        this.play_count = memberData?.play_count ?? null;
        this.mission_level = memberData?.mission_level ?? null;

    }
}

class MissionGolfState {
    id;
    game;
    condition_count;
    reward_count;
    is_enabled;
    is_clear;
    play_count;
    mission_level;
    constructor(memberData) {
        this.id = memberData?.id ?? null;
        this.game = memberData?.game ?? null;
        this.condition_count = memberData?.condition_count ?? null;
        this.reward_count = memberData?.reward_count ?? null;
        this.is_enabled = memberData?.is_enabled ?? null;
        this.is_clear = memberData?.is_clear ?? null;
        this.play_count = memberData?.play_count ?? null;
        this.mission_level = memberData?.mission_level ?? null;

    }
}





class MissionLevelState {
    member_no;
    business_grade;
    pmg_mission_level;
    cag_mission_level;
    golf_mission_level;// 골프



    constructor(memberData) {
        this.member_no = memberData?.member_no ?? null;
        this.business_grade = memberData?.business_grade ?? null;
        this.pmg_mission_level = memberData?.pmg_mission_level ?? null;
        this.cag_mission_level = memberData?.cag_mission_level ?? null;
        this.golf_mission_level = memberData?.golf_mission_level ?? null;// 골프



    }
}


export class MissionStore {
    rootStore;
    MissionPmgState = getSessionJson('MissionPmgState') ? new MissionPmgState(getSessionJson('MissionPmgState'), null) : new MissionPmgState();
    MissionCagState = getSessionJson('MissionCagState') ? new MissionCagState(getSessionJson('MissionCagState'), null) : new MissionCagState();
    MissionGolfState = getSessionJson('MissionGolfState') ? new MissionGolfState(getSessionJson('MissionGolfState'), null) : new MissionGolfState(); //골프

    MissionLevelState = getSessionJson('MissionLevelState') ? new MissionLevelState(getSessionJson('MissionLevelState'), null) : new MissionLevelState();




    PmgMissionLevelInfo = [];
    CagMissionLevelInfo = [];
    GolfMissionLevelInfo = []; //골프


    PmgMissionAmount = [];
    CagMissionAmount = [];
    GolfMissionAmount = []; //골프

    gameMissionLevelData = [];

    PmgMissionLevel = {};
    CagMissionLevel = {};
    GolfMissionLevel = {}; //골프



    RemainTime = 0;
    RemainHoursTime = 0;
    RemainMinsTime = 0;
    RemainSecsTime = 0;

    PmgMissionCount = 0;
    CagMissionCount = 0;
    GolfMissionCount = 0; //골프



    PmgMissionCommission = 0;
    CagMissionCommission = 0;
    GolfMissionCommission = 0; //골프




    MissionCagButton = 0;
    MissionPmgButton = 0;
    MissionGolfButton = 0; //골프


    PmgCheck = false;
    CagCheck = false;
    GolfCheck = false; // 골프




    isPmgMaxLevel = false;
    isCagMaxLevel = false;
    isGolfMaxLevel = false; // 골프



    BannerCheck = "Pmg";

    GradeMissionPmgCommission = '0';
    GradeMissionCagCommission = '0';
    GradeMissionGolfCommission = '0'; // 골프

    ErrorMissionGtade_01 = '';









    constructor(root) {
        makeObservable(this, {

            RemainTime: observable,
            MissionCagButton: observable,
            MissionPmgButton: observable,
            RemainHoursTime: observable,
            RemainMinsTime: observable,
            RemainSecsTime: observable,
            PmgCheck: observable,
            CagCheck: observable,
            BannerCheck: observable,
            PmgMissionCount: observable,
            CagMissionCount: observable,
            PmgMissionLevelInfo: observable,
            CagMissionLevelInfo: observable,
            PmgMissionCommission: observable,
            CagMissionCommission: observable,
            PmgMissionLevel: observable,
            CagMissionLevel: observable,
            gameMissionLevelData: observable,
            isPmgMaxLevel: observable,
            isCagMaxLevel: observable,
            GradeMissionPmgCommission: observable,
            GradeMissionCagCommission: observable,
            GolfMissionCommission: observable, // 골프
            GradeMissionGolfCommission: observable, // 골프
            GolfCheck: observable, // 골프
            isGolfMaxLevel: observable, // 골프
            GolfMissionLevelInfo: observable, // 골프
            GolfMissionLevel: observable, // 골프
            MissionGolfButton: observable, // 골프
            MissionGolfState: observable, // 골프
            GolfMissionCount: observable, // 골프
            PmgMissionAmount: observable,
            CagMissionAmount: observable,
            GolfMissionAmount: observable, // 골프
            ErrorMissionGtade_01: observable,





















            updateGolfMissionAmountTwo: action,
            setMissionError: action,
            updateGolfMissionAmount: action, // 골프
            updateCagMissionAmount: action,
            updatePmgMissionAmount: action,
            updatePmgMissionAmountTwo: action,
            updateCagMissionAmountTwo: action,
            setGolfClearTodayMission: action, // 골프
            setMissionGolfState: action, // 골프
            setGolfMissionCount: action, // 골프

            setMissionGolfButton: action, // 골프
            getGolfMissionTokenData: action, // 골프
            setGolfMissionTokenData: action, // 골프
            setisGameMaxLevel: action,
            setgameMissionLevelData: action,
            UserMissionUpgradeTokenSend: action,
            setCagMissionTokenData: action,
            setPmgMissionTokenData: action,
            getCagMissionTokenData: action,
            getPmgMissionTokenData: action,
            setCagMissionDataState: action,
            setPmgMissionDataState: action,
            setUserMissionLevelUpgrade: action,
            UserMissionLevelUpgrade: action,
            setUserMissionLevelState: action,
            getUserMissionLevelInfo: action,
            setCagMissionCount: action,
            setPmgMissionCount: action,
            setCheakMobile: action,
            setGameClearCheck: action,
            setCagClearTodayMission: action,
            setPmgClearTodayMission: action,
            setMissionCheck: action,
            // setCloverMissionBarTime:action,
            setRemainSecsTime: action,
            setRemainMinsTime: action,
            setRemainHoursTime: action,
            getUserMissionCount: action,
            setMissionPmgButton: action,
            setMissionCagButton: action,
            setMissionPmgState: action,
            setRemainTime: action,


        });

        this.rootStore = root;
        this.MissionPmgState = getSessionJson('MissionPmgState') ? new MissionPmgState(getSessionJson('MissionPmgState'), null) : new MissionPmgState();
        this.MissionCagState = getSessionJson('MissionCagState') ? new MissionCagState(getSessionJson('MissionCagState'), null) : new MissionCagState();
        this.MissionGolfState = getSessionJson('MissionGolfState') ? new MissionGolfState(getSessionJson('MissionGolfState'), null) : new MissionGolfState(); // 골프


        this.MissionLevelState = getSessionJson('MissionLevelState') ? new MissionLevelState(getSessionJson('MissionLevelState'), null) : new MissionLevelState();


        this.PmgMissionLevelInfo = [];
        this.CagMissionLevelInfo = [];
        this.GolfMissionLevelInfo = []; // 골프



        this.PmgMissionAmount = [];
        this.CagMissionAmount = [];
        this.GolfMissionAmount = []; // 골프


        this.gameMissionLevelData = [];



        this.PmgMissionLevel = {};
        this.CagMissionLevel = {};
        this.GolfMissionLevel = {}; // 골프




        this.RemainTime = 0;
        this.RemainHoursTime = 0;
        this.RemainMinsTime = 0;
        this.RemainSecsTime = 0;

        this.PmgMissionCount = 0;
        this.CagMissionCount = 0;
        this.GolfMissionCount = 0; // 골프


        this.PmgMissionCommission = 0;
        this.CagMissionCommission = 0;
        this.GolfMissionCommission = 0; // 골프





        this.MissionCagButton = 0;
        this.MissionPmgButton = 0;
        this.MissionGolfButton = 0; // 골프


        this.PmgCheck = false;
        this.CagCheck = false;
        this.GolfCheck = false; // 골프



        this.isPmgMaxLevel = false;
        this.isCagMaxLevel = false;
        this.isGolfMaxLevel = false; // 골프


        this.BannerCheck = "Pmg";


        this.GradeMissionPmgCommission = '0';
        this.GradeMissionCagCommission = '0';
        this.GradeMissionGolfCommission = '0'; // 골프

        this.ErrorMissionGtade_01 = '';













    }


    /**유저미션정보가져오기 */
    getUserMissionCount = (value) => {
        const api = '/getUserMissionCount';
        privatePost({ api: api, data: { member_no: parseInt(this.rootStore.loginStore.loginState.member_no) } }, (err, response) => {
            if (err) {
                // console.log(err);
            }
            else {
                // debug("getUserMissionCount", response?.data?.result);
                this.setCheakMobile();
                // console.log("MissionCount",response?.data?.result);
                let PmgMissions;
                let CagMissions;
                let GolfMissions; // 골프

                let Missions = response?.data?.result?.missions;
                let mission_level = response?.data?.result?.mission_level;
                this.setgameMissionLevelData(Missions);

                const remainTime = Number(response?.data?.result?.remain_time);
                const NaNRemainTime = Number.isNaN(remainTime);


                // let TimeS = new Date();

                // debug(TimeS, response?.data?.result);
                // console.log("remainTime",response?.data?.result?.remain_time);
                // console.log("NaNRemainTime",NaNRemainTime);


                if (NaNRemainTime === false) {
                    // console.log("11111111111",remainTime);
                    this.setRemainTime(remainTime);
                }
                else {
                    const RemainTime = Number(response?.data?.result?.remain_time);
                    // console.log("2222222222",RemainTime);
                    this.setRemainTime(RemainTime);
                }


                // console.log("getUserMissionCount", response?.data?.result);
                for (let i = 0; i < response?.data?.result?.missions.length; i++) {
                    if (Missions[i].game === 'pmg' && Missions[i].mission_level === mission_level.pmg) {
                        // console.log(Missions[i]);
                        // console.log(mission_level.pmg);
                        PmgMissions = Missions[i];
                    }
                    else if (Missions[i].game === 'cag' && Missions[i].mission_level === mission_level.cag) {
                        // console.log("Missions[i]",Missions[i].mission_level);
                        // console.log("mission_level.cag",mission_level.cag);
                        // console.log("Missions[i]",Missions[i]);
                        CagMissions = Missions[i];
                    }
                    else if (Missions[i].game === 'golf' && Missions[i].mission_level === mission_level.golf) {// 골프꺼 올리면 주석 처리 철회
                        // console.log("Missions[i]",Missions[i].mission_level);
                        // console.log("mission_level.cag",mission_level.cag);
                        // console.log("Missions[i]",Missions[i]);
                        GolfMissions = Missions[i];
                    }
                }
                if (PmgMissions) {
                    if (CagMissions) {
                        // console.log(CagMissions);
                        // console.log(PmgMissions);
                        this.setMissionPmgState(PmgMissions);
                        this.setMissionCagState(CagMissions);
                        this.setMissionGolfState(GolfMissions);

                        const PmgCount = PmgMissions.condition_count - PmgMissions.play_count;
                        const CagCount = CagMissions.condition_count - CagMissions.play_count;
                        const GolfCount = GolfMissions.condition_count - GolfMissions.play_count; //골프 업데이트 후 풀어
                        if (PmgCount > 0) {
                            this.setMissionPmgButton(0);
                        }
                        else if (PmgCount <= 0) {
                            this.setMissionPmgButton(1);
                        }
                        if (CagCount > 0) {
                            this.setMissionCagButton(0);
                        }
                        else if (CagCount <= 0) {
                            this.setMissionCagButton(1);
                        }
                        if (GolfCount > 0) {// 골프꺼 올리면 주석 처리 철회
                            this.setMissionGolfButton(0);
                        }
                        else if (GolfCount <= 0) {
                            this.setMissionGolfButton(1);
                        }
                        // eslint-disable-next-line
                        if (PmgMissions.is_clear == true) {
                            this.setMissionPmgButton(2);
                        }
                        // eslint-disable-next-line
                        if (CagMissions.is_clear == true) {
                            this.setMissionCagButton(2);
                        }
                        if (GolfMissions.is_clear == true) {// 골프꺼 올리면 주석 처리 철회
                            this.setMissionGolfButton(2);
                        }
                    }
                }
                // const remainTime = Number(response?.data?.result?.remain_time);
                // const NaNRemainTime = Number.isNaN(remainTime);
                // console.log("remainTime",response?.data?.result?.remain_time);
                // console.log("NaNRemainTime",NaNRemainTime);


                // if (NaNRemainTime === false) {
                //     console.log("11111111111",remainTime);
                //     this.setRemainTime(remainTime);
                // }
                // else {
                //     const RemainTime = Number(response?.data?.result?.remain_time);
                //     console.log("2222222222",RemainTime);
                //     this.setRemainTime(RemainTime);
                // }
            }
        });
    }




    setgameMissionLevelData(Missions) {
        this.gameMissionLevelData = Missions;
    }


    /**PmgMissionButton */
    setMissionPmgButton = (value) => {
        // console.log("setMissionCagButton",value);
        if (value === 0) {
            this.MissionPmgButton = 0;

        }
        else if (value === 1) {
            this.MissionPmgButton = 1;

        }
        else if (value === 2) {
            this.MissionPmgButton = 2;
        }
    }

    /**CagMissionButton */
    setMissionCagButton = (value) => {
        // console.log("setMissionCagButton",value);
        if (value === 0) {
            this.MissionCagButton = 0;
        }
        else if (value === 1) {
            this.MissionCagButton = 1;
        }
        else if (value === 2) {
            this.MissionCagButton = 2;
        }
    }

    /**GolfMissionButton */
    setMissionGolfButton = (value) => {  // 골프
        // console.log("setMissionCagButton",value);
        if (value === 0) {
            this.MissionGolfButton = 0;
        }
        else if (value === 1) {
            this.MissionGolfButton = 1;
        }
        else if (value === 2) {
            this.MissionGolfButton = 2;
        }
    }

    /**PmgData */
    setMissionPmgState(MissionPmgData) {
        const PmgCount = MissionPmgData.condition_count - MissionPmgData.play_count;
        // this.PmgMissionCount = PmgCount;
        // console.log(PmgCount);
        this.setPmgMissionCount(parseInt(PmgCount));
        // debug()
        // console.log("MissionPmgData",MissionPmgData);
        this.MissionPmgState = new MissionPmgState(MissionPmgData);
        if (MissionPmgData)
            setSessionJson("MissionPmgData", MissionPmgData);
        if (PmgCount >= 0) {
            /* eslint-disable */
            if (MissionPmgData.is_clear == false) {
                if (PmgCount > 0) {
                    this.setMissionPmgButton(0);
                }
                else if (PmgCount <= 0) {
                    this.setMissionPmgButton(1);
                }
            }
            /* eslint-disable */
            else if (MissionPmgData.is_clear == true) {
                // this.PmgMissionCount = 0;
                this.setPmgMissionCount(0);
                this.setMissionPmgButton(2);
            }
        }
        else {
            if (PmgCount < 0) {
                // this.PmgMissionCount = 0;
                // this.setPmgMissionCount(0);
                this.setMissionPmgButton(1);
            }
        }
    }
    setPmgMissionCount(value) {
        // console.log(value);
        this.PmgMissionCount = value;
    }

    /**CagData */
    setMissionCagState(MissionCagData) {
        const CagCount = MissionCagData.condition_count - MissionCagData.play_count;
        // this.CagMissionCount = CagCount;
        this.setCagMissionCount(parseInt(CagCount));
        // console.log("MissionCagData",MissionCagData);
        this.MissionCagState = new MissionCagState(MissionCagData);
        if (MissionCagData)
            setSessionJson("MissionCagData", MissionCagData);
        if (CagCount >= 0) {
            /* eslint-disable */
            if (MissionCagData.is_clear == false) {
                if (CagCount > 0) {
                    this.setMissionCagButton(0);
                }
                else if (CagCount <= 0) {
                    this.setMissionCagButton(1);
                }
            }
            /* eslint-disable */
            else if (MissionCagData.is_clear == true) {
                // this.CagMissionCount = 0;
                this.setCagMissionCount(0);
                this.setMissionCagButton(2);
            }
        }
        else {
            if (CagCount < 0) {
                // this.PmgMissionCount = 0;
                this.setCagMissionCount(0);
                this.setMissionCagButton(1);
            }
        }
    }

    setCagMissionCount(value) {
        this.CagMissionCount = value;
    }



    /**GolfData */
    setMissionGolfState(MissionGolfData) { // 골프
        const GolfCount = MissionGolfData.condition_count - MissionGolfData.play_count;
        // console.log(MissionGolfData);
        // this.CagMissionCount = CagCount;
        this.setGolfMissionCount(parseInt(GolfCount));
        // console.log("MissionCagData",MissionCagData);
        this.MissionGolfState = new MissionGolfState(MissionGolfData);
        if (MissionGolfData)
            setSessionJson("MissionCagData", MissionGolfData);
        if (GolfCount >= 0) {
            /* eslint-disable */
            if (MissionGolfData.is_clear == false) {
                if (GolfCount > 0) {
                    this.setMissionGolfButton(0);
                }
                else if (GolfCount <= 0) {
                    this.setMissionGolfButton(1);
                }
            }
            /* eslint-disable */
            else if (MissionGolfData.is_clear == true) {
                // this.CagMissionCount = 0;
                this.setGolfMissionCount(0);
                this.setMissionGolfButton(2);
            }
        }
        else {
            if (GolfCount < 0) {
                // this.PmgMissionCount = 0;
                this.setGolfMissionCount(0);
                this.setMissionGolfButton(1);
            }
        }
    }

    setGolfMissionCount(value) {  // 골프
        this.GolfMissionCount = value;
    }



    setCheakMobile(gameValue) {
        // console.log(gameValue);
        let UA = navigator.userAgent.toLowerCase();
        let gamevlaue = gameValue;
        // console.log("game",gamevlaue);
        // console.log(UA);
        const iTunesLink = 'https://itunes.apple.com';
        const playStoreLink = 'https://play.google.com/store/apps';
        const androidPmgPackage = 'com.brainsoft.pmg';
        const androidCagPackage = 'com.brainsoft.cube';
        const androidGolfPackage = 'com.brainsoft.golf';// 골프 // 골프 주소 확인 후 다시짜라

        const fallbackPmgUrl = 'deeplink://com.brainsoft.pmg';
        const fallbackCagUrl = 'deeplink://com.brainsoft.cube';
        const fallbackGolfUrl = 'deeplink://com.brainsoft.golf';// 골프 // 골프 주소 확인 후 다시짜라

        const schemeUrl = 'deeplink';
        if (gameValue !== "image_id") {
            // console.log("setCheakMobile",this.BannerCheck);
            if (UA.indexOf('android') > -1) {
                //안드로이드
                /* eslint-disable */
                if (gamevlaue == "Pmg") {
                    window.location.href = `${fallbackPmgUrl}`;
                    // 안드로이드의 크롬에서는 intent만 동작하기 때문에 intent로 호출해야함
                    setTimeout(function () {
                        window.location.href = `intent://${androidPmgPackage}#Intent;scheme=${schemeUrl};package=${androidPmgPackage};end`;
                    }, 1000);
                }
                else if (gamevlaue == "Cag") {
                    /* eslint-disable */
                    window.location.href = `${fallbackCagUrl}`;
                    // 안드로이드의 크롬에서는 intent만 동작하기 때문에 intent로 호출해야함
                    setTimeout(function () {
                        window.location.href = `intent://${androidCagPackage}#Intent;scheme=${schemeUrl};package=${androidCagPackage};end`;
                    }, 1000);
                }
                else if (gamevlaue == "Golf") {// 골프
                    /* eslint-disable */
                    window.location.href = `${fallbackGolfUrl}`;
                    // 안드로이드의 크롬에서는 intent만 동작하기 때문에 intent로 호출해야함
                    setTimeout(function () {
                        window.location.href = `intent://${androidGolfPackage}#Intent;scheme=${schemeUrl};package=${androidGolfPackage};end`;// 골프 주소 확인 후 다시짜라
                    }, 1000);
                }
            } else if (UA.indexOf("iphone") > -1 || UA.indexOf("ipad") > -1 || UA.indexOf("ipod") > -1) {
                //IOS
                window.location.href = `${iTunesLink}`;
                // return "ios";
            } else {
                //아이폰, 안드로이드 외
                /* eslint-disable */
                if (gamevlaue == "Pmg") {
                    // console.log("PmgWindowIn");
                    window.location.href = `${playStoreLink}/details?id=com.brainsoft.pmg`;
                }
                /* eslint-disable */
                if (gamevlaue == "Cag") {
                    // console.log("CagWindowIn");
                    window.location.href = `${playStoreLink}/details?id=com.brainsoft.cube`;
                }
                /* eslint-disable */
                if (gamevlaue == "Golf") { // 골프
                    // console.log("GolfWindowIn");
                    window.location.href = `${playStoreLink}/details?id=com.brainsoft.golf`;// 골프 주소 확인 후 다시짜라
                }
            }
        }
        else {
            // console.log("setCheakMobile",this.BannerCheck);
            if (UA.indexOf('android') > -1) {
                //안드로이드
                /* eslint-disable */
                if (this.BannerCheck == "Pmg") {
                    window.location.href = `${fallbackPmgUrl}`;
                    // 안드로이드의 크롬에서는 intent만 동작하기 때문에 intent로 호출해야함
                    setTimeout(function () {
                        window.location.href = `intent://${androidPmgPackage}#Intent;scheme=${schemeUrl};package=${androidPmgPackage};end`;
                    }, 1000);
                }
                else if (this.BannerCheck == "Cag") {
                    /* eslint-disable */
                    window.location.href = `${fallbackCagUrl}`;
                    // 안드로이드의 크롬에서는 intent만 동작하기 때문에 intent로 호출해야함
                    setTimeout(function () {
                        window.location.href = `intent://${androidCagPackage}#Intent;scheme=${schemeUrl};package=${androidCagPackage};end`;
                    }, 1000);
                }
                else if (this.BannerCheck == "Golf") {// 골프
                    // console.log(this.BannerCheck);
                    /* eslint-disable */
                    window.location.href = `${fallbackGolfUrl}`;
                    // 안드로이드의 크롬에서는 intent만 동작하기 때문에 intent로 호출해야함
                    setTimeout(function () {
                        window.location.href = `intent://${androidGolfPackage}#Intent;scheme=${schemeUrl};package=${androidGolfPackage};end`;// 골프 주소 확인 후 다시짜라
                    }, 1000);
                }
            } else if (UA.indexOf("iphone") > -1 || UA.indexOf("ipad") > -1 || UA.indexOf("ipod") > -1) {
                //IOS
                window.location.href = `${iTunesLink}`;
                // return "ios";
            } else {
                //아이폰, 안드로이드 외
                /* eslint-disable */
                if (this.BannerCheck == "Pmg") {
                    // console.log("PmgWindowIn");
                    window.location.href = `${playStoreLink}/details?id=com.brainsoft.pmg`;
                }
                /* eslint-disable */
                if (this.BannerCheck == "Cag") {
                    // console.log("CagWindowIn");
                    window.location.href = `${playStoreLink}/details?id=com.brainsoft.cube`;
                }
                /* eslint-disable */
                if (this.BannerCheck == "Golf") {// 골프
                    // console.log("GolfWindowIn");
                    window.location.href = `${playStoreLink}/details?id=com.brainsoft.golf`;// 골프 주소 확인 후 다시짜라
                }

            }
        }
    }




    /** MissionClearCheck */
    setMissionCheck = (ClickData) => {
        // debug(ClickData);
        /* eslint-disable */
        if (ClickData.game == "Pmg") {
            /* eslint-disable */
            if (ClickData.Count == 0) {
                /* eslint-disable */
                if (this.MissionPmgState.play_count == 0) {
                    this.setMissionPmgButton(1);
                }
                /* eslint-disable */
                if (ClickData.clear == false) {
                    this.setMissionPmgButton(1);
                }
                else {
                    this.setMissionPmgButton(2);
                    this.setCheakMobile("Pmg");
                }
            }
            else {
                this.setCheakMobile("Pmg");
            }
        }
        /* eslint-disable */
        else if (ClickData.game == "Cag") {
            /* eslint-disable */
            if (ClickData.Count == 0) {
                /* eslint-disable */
                if (this.MissionCagState.play_count == 0) {
                    this.setMissionCagButton(1);
                }
                if (ClickData.clear == false) {
                    this.setMissionCagButton(1);
                }
                else {
                    this.setMissionCagButton(2);
                    this.setCheakMobile("Cag");
                }
            }
            else {
                this.setCheakMobile("Cag");
            }
        }
        /* eslint-disable */
        else if (ClickData.game == "golf") {// 골프꺼 올리면 주석 처리 철회
            /* eslint-disable */
            if (ClickData.Count == 0) {
                /* eslint-disable */
                if (this.MissionGolfState.play_count == 0) {
                    this.setMissionGolfButton(1);
                }
                if (ClickData.clear == false) {
                    this.setMissionGolfButton(1);
                }
                else {
                    this.setMissionGolfButton(2);
                    this.setCheakMobile("Golf");
                }
            }
            else {
                this.setCheakMobile("Golf");// 만들어야됨
            }
        }
    }




    /**Pmg오늘미션클리어 */
    setPmgClearTodayMission = (value) => {
        // console.log(value);
        const api = "/clearTodayMission";
        privatePost({ api: api, data: { member_no: parseInt(this.rootStore.loginStore.loginState.member_no), id: this.MissionPmgState.id } }, (err, response) => {
            if (err) {
                // console.log(err); 
                if (err.errorCode === 3600) {
                    this.setMissionPmgButton(2);
                    return alert("금일 미션이 완료 되었습니다");
                }
                else if (err.errorCode === 3601) {
                    this.setMissionPmgButton(0);
                    return alert("플레이 횟수가 모자랍니다");
                }
                else if (err.errorCode === 3602) {
                    this.setMissionPmgButton(0);
                    return alert("완료 할 수 없는 미션입니다");
                }
            }
            else {
                this.setMissionPmgButton(2);
                this.setGameClearCheck("Pmg");
                this.rootStore.loginStore.getCloverCount();
            }
        });
    }


    /**Cag오늘미션클리어 */
    setCagClearTodayMission = () => {
        const api = "/clearTodayMission";
        privatePost({ api: api, data: { member_no: parseInt(this.rootStore.loginStore.loginState.member_no), id: this.MissionCagState.id } }, (err, response) => {
            if (err) {
                if (err.errorCode === 3600) {
                    this.setMissionCagButton(2);
                    return alert("금일 미션이 완료 되었습니다");
                }
                else if (err.errorCode === 3601) {
                    this.setMissionCagButton(0);
                    return alert("플레이 횟수가 모자랍니다");
                }
                else if (err.errorCode === 3602) {
                    this.setMissionCagButton(0);
                    return alert("완료 할 수 없는 미션입니다");
                }
            }
            else {
                this.setMissionCagButton(2);
                this.setGameClearCheck("Cag");
                this.rootStore.loginStore.getCloverCount();
            }
        });
    }

    /**Golf오늘미션클리어 */
    setGolfClearTodayMission = () => {  // 골프
        const api = "/clearTodayMission";
        // console.log(this.MissionGolfState.id);
        privatePost({ api: api, data: { member_no: parseInt(this.rootStore.loginStore.loginState.member_no), id: this.MissionGolfState.id } }, (err, response) => {
            if (err) {
                // console.log(err);
                if (err.errorCode === 3600) {
                    this.setMissionGolfButton(2);
                    return alert("금일 미션이 완료 되었습니다");
                }
                else if (err.errorCode === 3601) {
                    this.setMissionGolfButton(0);
                    return alert("플레이 횟수가 모자랍니다");
                }
                else if (err.errorCode === 3602) {
                    this.setMissionGolfButton(0);
                    return alert("완료 할 수 없는 미션입니다");
                }
            }
            else {
                this.setMissionGolfButton(2);
                this.setGameClearCheck("golf");// 골프꺼 올리면 주석 처리 철회
                this.rootStore.loginStore.getCloverCount();
            }
        });
    }

    /**클리어체크 */
    setGameClearCheck(value) {
        // console.log(value);
        if (value == "pmg") {
            this.PmgCheck = true;
        }
        else if (value == "Cag") {
            this.CagCheck = true;
        }
        else if (value == "Golf") { // 골프
            this.GolfCheck = true;
        }
    }

    setRemainTime = (value) => {
        // console.log(value);
        // console.log(typeof value);
        const NaNSeconds = Number.isNaN(value);
        // console.log(new Date());
        if (NaNSeconds === false) {
            this.RemainTime = value;
            let today = new Date(); // today 객체에 Date()의 결과를 넣어줬다
            let time = {
                seconds: today.getSeconds()
            };
            this.setRemainHoursTime();
            this.setRemainMinsTime();
            this.setRemainSecsTime(time.seconds);
        }
        else {
            return;
        }
    }


    setRemainHoursTime(value) {
        // console.log("setRemainHoursTime",value);
        let hours = Math.floor(this.RemainTime / 3600);
        if (hours < 10) {
            this.RemainHoursTime = "0" + hours;
        }
        else {
            this.RemainHoursTime = hours;
        }
    }

    setRemainMinsTime(value) {
        // console.log("setRemainMinsTime",value);
        let hours = Math.floor(this.RemainTime / 3600);
        let mins = Math.floor((this.RemainTime - hours * 3600) / 60);
        if (mins < 10) {
            this.RemainMinsTime = "0" + mins;
        }
        else {
            this.RemainMinsTime = mins;
        }
    }

    setRemainSecsTime(value) {
        let CurrentTime = 60 - value;
        let secs = Math.floor(this.RemainTime % 60);
        if (secs === CurrentTime) {
            this.RemainSecsTime = secs;
            if (secs < 10) {
                this.RemainSecsTime = "0" + secs;
            }
        }
        else if (secs !== CurrentTime) {
            this.RemainSecsTime = CurrentTime;
            if (CurrentTime < 10) {
                this.RemainSecsTime = "0" + CurrentTime;
            }
        }
        if (this.RemainSecsTime === 60) {
            this.RemainSecsTime = "00";
        }


    }





    /**유저미션레벨정보가져오기 
    * @param {number} member_no 멤버넘버
    * @param {number} business_grade business_grade
     */
    getUserMissionLevelInfo = (value, Check) => {

        // console.log(value, Check);

        //의미 없어 보이지만 초기화 하는것임
        this.PmgMissionLevelInfo = [];
        this.CagMissionLevelInfo = [];
        this.GolfMissionLevelInfo = []; // 골프


        const api = '/getMemberMissionInfo';
        const memberNo = parseInt(this.rootStore?.loginStore?.loginState?.member_no);
        let businessGrade = parseInt(this.rootStore?.UserProfileStore?.RecommenderInfoState?.business_grade);
        let BGradeNaN = Number.isNaN(businessGrade);
        let data = {
            member_no: memberNo,
            business_grade: businessGrade,
        }

        // console.log("getUserMissionLevelInfo",data);

        if (memberNo) {
            if (BGradeNaN === false) {
                privatePost({ api: api, data: data }, (err, response) => {
                    if (err) {
                        // console.log("getUserMissionLevelInfo_Error", err);
                        if (err.errorCode === 501) {
                            return alert(this.rootStore?.loginStore?.ErrorGuide_501);
                        }
                        else {
                            // console.log("errIn");
                            return alert(this.rootStore?.loginStore?.ErrorGuide_clover_001);
                        }
                    }
                    else {
                        // console.log("setUserMissionLevelState", response?.data?.result);
                        // this.setUserMissionLevelState(response?.data?.result);
                        // let TimeS = new Date();
                        // debug(TimeS, response?.data?.result);
                        // let PmgData = response?.data?.result.All_level_data[0];
                        // let CagData = response?.data?.result.All_level_data[2];
                        let PmgData;
                        let CagData;
                        let GolfData; // 골프

                        let Pmg = [];
                        let Cag = [];
                        let Golf = []; // 골프

                        for (let i = 0; i < response?.data?.result.All_level_data.length; i++) {
                            if (response?.data?.result.All_level_data[i].game === "pmg") {
                                Pmg.push(response?.data?.result.All_level_data[i]);
                            }
                            else if (response?.data?.result.All_level_data[i].game === "cag") {
                                Cag.push(response?.data?.result.All_level_data[i]);
                            }
                            else if (response?.data?.result.All_level_data[i].game === "golf") {// 골프꺼 올리면 주석 처리 철회
                                Golf.push(response?.data?.result.All_level_data[i]);
                            }
                        }
                        if (Pmg.length === 2) {
                            this.PmgMissionAmount = Pmg;
                            // if (Check === "Amount") {
                            //     this.updatePmgMissionAmount();
                            // }
                            if (Pmg[0].mission_level > Pmg[1].mission_level) {
                                PmgData = Pmg[0];
                            }
                            else if (Pmg[0].mission_level < Pmg[1].mission_level) {
                                PmgData = Pmg[1];
                            }
                        }
                        else if (Pmg.length === 1) {
                            this.PmgMissionAmount = Pmg;
                            // this.isPmgMaxLevel = true;
                            this.setisGameMaxLevel("pmg");
                            // if (Check === "Amount") {
                            //     // console.log("Good");
                            //     this.updatePmgMissionAmount();
                            // }
                            PmgData = Pmg[0];
                        }
                        if (Cag.length === 2) {
                            this.CagMissionAmount = Cag;
                            if (Cag[0].mission_level > Cag[1].mission_level) {
                                CagData = Cag[0];
                            }
                            else if (Cag[0].mission_level < Cag[1].mission_level) {
                                CagData = Cag[1];
                            }
                        }
                        else if (Cag.length === 1) {
                            this.CagMissionAmount = Cag;
                            // this.isCagMaxLevel = true;
                            this.setisGameMaxLevel("cag");
                            CagData = Cag[0];
                        }
                        if (Golf.length === 2) {// 골프꺼 올리면 주석 처리 철회
                            this.GolfMissionAmount = Golf;
                            if (Golf[0].mission_level > Golf[1].mission_level) {
                                GolfData = Golf[0];
                            }
                            else if (Golf[0].mission_level < Golf[1].mission_level) {
                                GolfData = Golf[1];
                            }
                        }
                        else if (Golf.length === 1) {
                            this.GolfMissionAmount = Golf;
                            this.setisGameMaxLevel("golf");// 골프꺼 올리면 주석 처리 철회
                            GolfData = Golf[0];
                        }
                        if (value === "OPEN") {
                            // console.log("=-------------------------------------MissionTokenDataIN");
                            if (response?.data?.result.All_level_data.length > 2) {
                                if (PmgData) {// 골프꺼 올리면 주석 처리 철회
                                    if (CagData) {
                                        if (GolfData) {
                                            // console.log("Token");
                                            if (Check !== "MissionAmount") {
                                                this.updatePmgMissionAmount();
                                            }
                                            else {
                                                this.getPmgMissionTokenData(PmgData, CagData, GolfData);
                                            }
                                        }
                                    }
                                }
                                // if (PmgData) {// 골프꺼 올리면 주석 처리 철회
                                //     if (CagData) {
                                //         // console.log("Token");
                                //         // console.log("MissioninfoCheck = ", Check);// 테스트용 로그 지워도 됨
                                //         if (Check !== "MissionAmount") {
                                //             this.updatePmgMissionAmount();
                                //         }
                                //         else {
                                //             this.getPmgMissionTokenData(PmgData, CagData);
                                //         }
                                //         // this.setUserMissionLevelState(response?.data?.result);
                                //     }
                                // }
                            }
                        }
                        // this.getCagMissionTokenData(CagData);
                        this.setUserMissionLevelState(response?.data?.result);
                    }
                });
            }

        }
    };


    updatePmgMissionAmount() {// 되는지 테스트 중 (PMG_ONE)


        const api = '/UserupdateMemberMissionAmount';

        let PmgData = toJS(this.PmgMissionAmount);

        const memberNo = parseInt(this.rootStore?.loginStore?.loginState?.member_no);


        let firstAmountData = {
            member_no: memberNo,
            id: PmgData[0]?.id,
            game: PmgData[0]?.game,
            condition_count: PmgData[0]?.condition_count,
            reward_count: PmgData[0]?.reward_count,
            is_enabled: PmgData[0]?.is_enabled,
            mission_level: PmgData[0]?.mission_level,
            business_grade: PmgData[0]?.business_grade,
            amount_count: PmgData[0]?.amount_count,
            krw_count: PmgData[0]?.krw_count,
        };


        let lastAmountData = {
            member_no: memberNo,
            id: PmgData[1]?.id,
            game: PmgData[1]?.game,
            condition_count: PmgData[1]?.condition_count,
            reward_count: PmgData[1]?.reward_count,
            is_enabled: PmgData[1]?.is_enabled,
            mission_level: PmgData[1]?.mission_level,
            business_grade: PmgData[1]?.business_grade,
            amount_count: PmgData[1]?.amount_count,
            krw_count: PmgData[1]?.krw_count,
        };


        privatePost({ api: api, data: firstAmountData }, (err, response) => {
            if (err) {
                // console.log("P_MissionAmount_one ", err);// 에러처리 해야함
                this.setMissionError(this.rootStore?.loginStore?.ErrorGuide_clover_001);
            }
            else {
                if (PmgData.length === 2) {
                    // console.log("one_Good");
                    this.updatePmgMissionAmountTwo(lastAmountData);
                }
                else {
                    // console.log("one_BAD");
                    this.updateCagMissionAmount();
                }
            }

        });

    };


    updatePmgMissionAmountTwo(data) {// 되는지 테스트 중 (PMG_TWO)

        const api = '/UserupdateMemberMissionAmount';

        privatePost({ api: api, data: data }, (err, response) => {
            if (err) {
                // console.log("P_MissionAmount_two ", err);// 에러처리 해야함
                this.setMissionError(this.rootStore?.loginStore?.ErrorGuide_clover_001);
            }
            else {
                // console.log("Two_Good");
                this.updateCagMissionAmount();
            }

        });

    }

    updateCagMissionAmount() {// 되는지 테스트 중 (Cag_one)

        const api = '/UserupdateMemberMissionAmount';

        let CagData = toJS(this.CagMissionAmount);


        const memberNo = parseInt(this.rootStore?.loginStore?.loginState?.member_no);



        let firstAmountData = {
            member_no: memberNo,
            id: CagData[0]?.id,
            game: CagData[0]?.game,
            condition_count: CagData[0]?.condition_count,
            reward_count: CagData[0]?.reward_count,
            is_enabled: CagData[0]?.is_enabled,
            mission_level: CagData[0]?.mission_level,
            business_grade: CagData[0]?.business_grade,
            amount_count: CagData[0]?.amount_count,
            krw_count: CagData[0]?.krw_count,

        };

        let lastAmountData = {
            member_no: memberNo,
            id: CagData[1]?.id,
            game: CagData[1]?.game,
            condition_count: CagData[1]?.condition_count,
            reward_count: CagData[1]?.reward_count,
            is_enabled: CagData[1]?.is_enabled,
            mission_level: CagData[1]?.mission_level,
            business_grade: CagData[1]?.business_grade,
            amount_count: CagData[1]?.amount_count,
            krw_count: CagData[1]?.krw_count,

        };

        privatePost({ api: api, data: firstAmountData }, (err, response) => {
            if (err) {
                // console.log("C_MissionAmount_one ", err);// 에러처리 해야함
                this.setMissionError(this.rootStore?.loginStore?.ErrorGuide_clover_001);
            }
            else {
                // console.log("one_Good");
                if (CagData.length === 2) {
                    this.updateCagMissionAmountTwo(lastAmountData);
                }
                else {
                    this.updateGolfMissionAmount();// 골프는 만들어야됨 똑같이 
                    // this.getUserMissionLevelInfo("OPEN", "MissionAmount");// GameMissionAmountLastCall -- 게임 추가되면 끝부분 콜에 불어오기
                }
            }

        });

    };

    updateCagMissionAmountTwo(data) {// 되는지 테스트 중 (Cag_two)

        const api = '/UserupdateMemberMissionAmount';

        privatePost({ api: api, data: data }, (err, response) => {
            if (err) {
                // console.log("C_MissionAmount_TWO ", err);// 에러처리 해야함
                this.setMissionError(this.rootStore?.loginStore?.ErrorGuide_clover_001);
            }
            else {
                // console.log("Two_Good");
                // this.updateCagMissionAmount();
                this.updateGolfMissionAmount();// 골프는 만들어야됨 똑같이 
                // this.getUserMissionLevelInfo("OPEN", "MissionAmount");// GameMissionAmountLastCall -- 게임 추가되면 끝부분 콜에 불어오기
            }

        });

    }





    updateGolfMissionAmount() {  // 골프

        // const api = "/UserupdateMemberMissionAmount";
        let GolfData = toJS(this.GolfMissionAmount);


        const api = '/UserupdateMemberMissionAmount';


        const memberNo = parseInt(this.rootStore?.loginStore?.loginState?.member_no);


        // console.log(this.GolfMissionAmount);
        // console.log(GolfData);

        let firstAmountData = {
            member_no: memberNo,
            id: GolfData[0]?.id,
            game: GolfData[0]?.game,
            condition_count: GolfData[0]?.condition_count,
            reward_count: GolfData[0]?.reward_count,
            is_enabled: GolfData[0]?.is_enabled,
            mission_level: GolfData[0]?.mission_level,
            business_grade: GolfData[0]?.business_grade,
            amount_count: GolfData[0]?.amount_count,
            krw_count: GolfData[0]?.krw_count,

        };

        let lastAmountData = {
            member_no: memberNo,
            id: GolfData[1]?.id,
            game: GolfData[1]?.game,
            condition_count: GolfData[1]?.condition_count,
            reward_count: GolfData[1]?.reward_count,
            is_enabled: GolfData[1]?.is_enabled,
            mission_level: GolfData[1]?.mission_level,
            business_grade: GolfData[1]?.business_grade,
            amount_count: GolfData[1]?.amount_count,
            krw_count: GolfData[1]?.krw_count,

        };


        privatePost({ api: api, data: firstAmountData }, (err, response) => {
            if (err) {
                // console.log("G_MissionAmount_one ", err);// 에러처리 해야함
                this.setMissionError(this.rootStore?.loginStore?.ErrorGuide_clover_001);
            }
            else {
                // console.log("one_Good", response);
                if (GolfData.length === 2) {
                    this.updateGolfMissionAmountTwo(lastAmountData);
                }
                else {
                    // this.updateGolfMissionAmount();// 골프는 만들어야됨 똑같이 
                    this.getUserMissionLevelInfo("OPEN", "MissionAmount");// GameMissionAmountLastCall -- 게임 추가되면 끝부분 콜에 불어오기
                }
            }

        });

    }

    updateGolfMissionAmountTwo(data) {

        const api = '/UserupdateMemberMissionAmount';

        privatePost({ api: api, data: data }, (err, response) => {
            if (err) {
                // console.log("G_MissionAmount_TWO ", err);// 에러처리 해야함
                this.setMissionError(this.rootStore?.loginStore?.ErrorGuide_clover_001);
            }
            else {
                // console.log("Two_Good", response);
                this.getUserMissionLevelInfo("OPEN", "MissionAmount");// GameMissionAmountLastCall -- 게임 추가되면 끝부분 콜에 불어오기
            }

        });

    }

    setisGameMaxLevel(value) {
        if (value === "pmg") {
            this.isPmgMaxLevel = true;
        }
        else if (value === "cag") {
            this.isCagMaxLevel = true;
        }
        else if (value === "golf") {// 골프꺼 올리면 주석 처리 철회
            this.isGolfMaxLevel = true;
        }

    }

    getPmgMissionTokenData(PmgData, CagData, GolfData) {
        const address = "MissionAddress";
        const amount = Math.ceil(PmgData?.amount_count);
        const CommissionData = { 'member_no': parseInt(this.rootStore.loginStore.loginState.member_no), 'address': String(address), 'amount': parseInt(amount) };
        const getCommissionEtherapi = '/getTokenTranCommisions';
        console.log(-102);
        if (PmgData.length !== 0) {
            privatePost({ api: getCommissionEtherapi, data: CommissionData }, (err, response) => {
                if (err) {
                    // console.log(err);
                    // this.GradeMissionPmgCommission = err.errorMessage;
                    if (err.errorCode === 3200) {
                        this.GradeMissionPmgCommission = this.rootStore.loginStore.ErrorGuide_clover_userProfile_01;
                        // return alert("유저를 찾을 수 없습니다.");
                    }
                    else if (err.errorCode === 3102) {
                        this.GradeMissionPmgCommission = this.rootStore.loginStore.ErrorGuide_clover_userProfile_02;
                        // return alert("등급이 해당되지 않습니다.");
                    }
                    else {
                        this.GradeMissionPmgCommission = this.rootStore.loginStore.ErrorGuide_clover_userProfile_02;
                        // return alert("등급이 해당되지 않습니다.");
                    }
                } else {
                    // console.log(response?.data?.result);
                    if (response?.data?.result) {
                        // console.log("SSSS", response?.data?.result.commision);
                        this.setPmgMissionTokenData(ChangeDecomalPoint(response?.data?.result.commision, 10000000000));
                        this.getCagMissionTokenData(CagData, GolfData);
                    }
                    return
                }
            });
        }
    }

    setPmgMissionTokenData(Commision) {
        this.PmgMissionCommission = Commision;
    }

    getCagMissionTokenData(CagData, GolfData) {
        const address = "MissionAddress";
        const amount = Math.ceil(CagData?.amount_count);
        const CommissionData = { 'member_no': parseInt(this.rootStore.loginStore.loginState.member_no), 'address': String(address), 'amount': parseInt(amount) };
        const getCommissionEtherapi = '/getTokenTranCommisions';
        console.log(-103);
        if (CagData.length !== 0) {
            privatePost({ api: getCommissionEtherapi, data: CommissionData }, (err, response) => {
                if (err) {
                    // console.log(err);
                    // this.GradeMissionPmgCommission = err.errorMessage;
                    if (err.errorCode === 501) {
                        this.GradeMissionPmgCommission = this.rootStore?.loginStore?.ErrorGuide_501;
                        return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
                    }
                    else {
                        this.GradeMissionPmgCommission = this.rootStore?.loginStore?.ErrorGuide_clover_001;
                        return alert(this.rootStore?.loginStore?.ErrorGuide_clover_001);//새로고침을 시도해주세요.
                    }

                } else {
                    // console.log(response?.data?.result);
                    if (response?.data?.result) {
                        // console.log("DDDD", response?.data?.result.commision);
                        this.setCagMissionTokenData(ChangeDecomalPoint(response?.data?.result.commision, 10000000000));
                        this.getGolfMissionTokenData(GolfData);// 골프꺼 올리면 주석 처리 철회

                    }
                    return
                }
            });
        }
    }

    setCagMissionTokenData(Commision) {
        this.CagMissionCommission = Commision;
    }

    getGolfMissionTokenData(GolfData) { // 골프
        const address = "MissionAddress";
        const amount = Math.ceil(GolfData?.amount_count);
        const CommissionData = { 'member_no': parseInt(this.rootStore.loginStore.loginState.member_no), 'address': String(address), 'amount': parseInt(amount) };
        const getCommissionEtherapi = '/getTokenTranCommisions';
        console.log(-104);

        if (GolfData.length !== 0) {
            privatePost({ api: getCommissionEtherapi, data: CommissionData }, (err, response) => {
                if (err) {
                    // console.log(err);
                    // this.GradeMissionPmgCommission = err.errorMessage;
                    if (err.errorCode === 501) {
                        this.GradeMissionPmgCommission = this.rootStore?.loginStore?.ErrorGuide_501;
                        return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
                    }
                    else {
                        this.GradeMissionPmgCommission = this.rootStore?.loginStore?.ErrorGuide_clover_001;
                        return alert(this.rootStore?.loginStore?.ErrorGuide_clover_001);//새로고침을 시도해주세요.
                    }

                } else {
                    // console.log(response?.data?.result);
                    if (response?.data?.result) {
                        this.setGolfMissionTokenData(ChangeDecomalPoint(response?.data?.result.commision, 10000000000));
                    }
                    return
                }
            });
        }
    }

    setGolfMissionTokenData(Commision) { // 골프
        this.GolfMissionCommission = Commision;
    }


    async setUserMissionLevelState(Data) {
        let memberLevelData = Data?.member_level_data ?? null;
        let AllMissionLevelData = Data?.All_level_data ?? null;
        // let NextMissionLevelData = Data?.Next_level_data ?? null;

        let PmgData = [];
        let PmgMissionsData = [];
        let CagData = [];
        let CagMissionsData = [];

        let GolfData = []; // 골프
        let GolfMissionsData = []; // 골프


        if (memberLevelData !== null) {
            let Missiondata = {
                member_no: memberLevelData.member_no,
                business_grade: memberLevelData.business_grade,
                pmg_mission_level: memberLevelData.pmg_mission_level,
                cag_mission_level: memberLevelData.cag_mission_level,
                golf_mission_level: memberLevelData.golf_mission_level, // 골프
            }
            // console.log('Missiondata',memberLevelData);
            this.MissionLevelState = new MissionLevelState(Missiondata);

            if (AllMissionLevelData) {
                if (AllMissionLevelData.length === 6) {
                    if (AllMissionLevelData[0].game === 'pmg' && AllMissionLevelData[1].game === 'pmg') {
                        PmgData = [AllMissionLevelData[0], AllMissionLevelData[1]];
                        this.setPmgMissionDataState(PmgData);
                    }
                    if (AllMissionLevelData[2].game === 'cag' && AllMissionLevelData[3].game === 'cag') {
                        CagData = [AllMissionLevelData[2], AllMissionLevelData[3]];
                        this.setCagMissionDataState(CagData);
                    }
                    if (AllMissionLevelData[4].game === 'golf' && AllMissionLevelData[5].game === 'golf') {// 골프꺼 올리면 주석 처리 철회
                        GolfData = [AllMissionLevelData[4], AllMissionLevelData[5]];
                        this.setGolfMissionDataState(GolfData);
                    }
                }
                else {
                    for (let i = 0; i < AllMissionLevelData.length; i++) {
                        // console.log("4", AllMissionLevelData[i].game);
                        if (AllMissionLevelData[i].game === 'pmg') {
                            PmgData.push(AllMissionLevelData[i]);
                        }
                        else if (AllMissionLevelData[i].game === 'cag') {
                            CagData.push(AllMissionLevelData[i]);
                        }
                        else if (AllMissionLevelData[i].game === 'golf') {// 골프꺼 올리면 주석 처리 철회
                            GolfData.push(AllMissionLevelData[i]);
                        }
                    }
                    // console.log("PmgData", PmgData);
                    // console.log("CagData", CagData);
                    if (PmgData.length === 1) {
                        // console.log(PmgData[0]);
                        this.setPmgMissionDataState(PmgData);
                    }
                    else {
                        if (PmgData[0].mission_level < PmgData[1].mission_level) {
                            PmgMissionsData.unshift(PmgData[0]);
                            PmgMissionsData.push(PmgData[1]);
                        }
                        else if (PmgData[0].mission_level > PmgData[1].mission_level) {
                            PmgMissionsData.unshift(PmgData[1]);
                            PmgMissionsData.push(PmgData[0]);
                        }
                        this.setPmgMissionDataState(PmgMissionsData);
                    }
                    if (CagData.length === 1) {
                        // console.log(CagData);
                        this.setCagMissionDataState(CagData);
                    }
                    else {
                        if (CagData[0].mission_level < CagData[1].mission_level) {
                            CagMissionsData.unshift(CagData[0]);
                            CagMissionsData.push(CagData[1]);
                        }
                        else if (CagData[0].mission_level > CagData[1].mission_level) {
                            CagMissionsData.push(CagData[0]);
                            CagMissionsData.unshift(CagData[1]);
                        }
                        // console.log(CagMissionsData);
                        if (CagMissionsData.length === 2) {
                            this.setCagMissionDataState(CagMissionsData);
                        }
                    }
                    if (GolfData.length === 1) {// 골프꺼 
                        // console.log(GolfData);
                        this.setGolfMissionDataState(GolfData);
                    }
                    else {
                        if (GolfData[0].mission_level < GolfData[1].mission_level) {
                            GolfMissionsData.unshift(GolfData[0]);
                            GolfMissionsData.push(GolfData[1]);
                        }
                        else if (GolfData[0].mission_level > GolfData[1].mission_level) {
                            GolfMissionsData.push(GolfData[0]);
                            GolfMissionsData.unshift(GolfData[1]);
                        }
                        // console.log(GolfMissionsData);
                        if (GolfMissionsData.length === 2) {
                            this.setGolfMissionDataState(GolfMissionsData);
                        }
                    }
                }
            }


        }

    };


    setPmgMissionDataState(PmgData) {
        let Data = toJS(PmgData);
        // console.log("PmgData", Data);
        // console.log("setPmgMissionDataState", PmgData);
        if (PmgData.length == 2) {
            if (Data[0].mission_level < Data[1].mission_level) {
                this.PmgMissionLevelInfo.unshift(Data[0]);
                this.PmgMissionLevelInfo.push(Data[1]);
            }
            else {
                this.PmgMissionLevelInfo.unshift(Data[1]);
                this.PmgMissionLevelInfo.push(Data[0]);
            }
        }
        else {
            // console.log(PmgData);
            this.PmgMissionLevelInfo.push(Data[0]);
            this.PmgMissionLevel = Data[0];
        }
    }


    setCagMissionDataState(CagData) {
        let Data = toJS(CagData);
        // console.log("CagData", Data);

        if (CagData.length == 2) {
            if (Data[0].mission_level < Data[1].mission_level) {
                this.CagMissionLevelInfo.unshift(Data[0]);
                this.CagMissionLevelInfo.push(Data[1]);
            }
            else {
                this.CagMissionLevelInfo.unshift(Data[1]);
                this.CagMissionLevelInfo.push(Data[0]);
            }
        }
        else if (this, this.isCagMaxLevel === true) {
            this.CagMissionLevelInfo.push(Data[0]);
        }
        else {
            this.CagMissionLevelInfo.push(Data[0]);
        }
    }


    setGolfMissionDataState(GolfData) { // 골프
        let Data = toJS(GolfData);
        // console.log("GolfData", Data);
        if (GolfData.length == 2) {
            if (Data[0].mission_level < Data[1].mission_level) {
                this.GolfMissionLevelInfo.unshift(Data[0]);
                this.GolfMissionLevelInfo.push(Data[1]);
            }
            else {
                this.GolfMissionLevelInfo.unshift(Data[1]);
                this.GolfMissionLevelInfo.push(Data[0]);
            }
        }
        else if (this, this.isGolfMaxLevel === true) {
            this.GolfMissionLevelInfo.push(Data[0]);
        }
        else {
            this.GolfMissionLevelInfo.push(Data[0]);
        }
    }


    //업그레이드 비용 보내기
    UserMissionUpgradeTokenSend(value, data) {

        // //테스트 그냥 업글 하기
        // console.log("value",value);
        // console.log("data",data);
        // const EtherCoinCommission = parseFloat(0.008957423) - data.Token;// TEST
        // this.UserMissionLevelUpgrade(value); // TEST 꼭 주석하고 빌드해야됨

        const address = "MissionAddress";
        const amount = Number(data.amount_count);

        const StandData = this.rootStore.CoinStore.StandData;
        // const EtherCoinCommission = this.rootStore.CoinStore.CountEtherCoin - data.Token;
        const EtherCoinCommission = parseFloat(this.rootStore.CoinStore.EtherData) - data.Token;

        const StandCoinCommission = StandData - amount;

        // console.log(EtherCoinCommission);


        const CoinTrnasferData = { 'member_no': parseInt(this.rootStore.loginStore.loginState.member_no), 'address': String(address), 'amount': Number(amount) }


        // console.log("UpGrade", CoinTrnasferData);

        if (this.isPmgMaxLevel === true && this.isCagMaxLevel === true) {
            return alert(this.rootStore?.loginStore?.ErrorGuide_clover_002);//최종레벨에 도달 하셨습니다.
        }
        else {
            if (value === "pmg") {
                if (this.isPmgMaxLevel === true) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_clover_003);//팡팡 최종레벨에 도달하셨습니다.
                }
            }
            else if (value === "cag") {
                if (this.isCagMaxLevel === true) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_clover_004);//큐브 최종레벨에 도달하셨습니다.
                }
            }
            else if (value === "golf") {// 골프꺼 올리면 주석 처리 철회
                if (this.isCagMaxLevel === true) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_clover_020);//큐브 최종레벨에 도달하셨습니다.
                }
            }
        }


        const getsendTokenUserapi = '/sendTokenUser';
        if (data.Token !== 0) {
            if (EtherCoinCommission > 0) {
                if (StandCoinCommission > 0) {
                    if (isNaN(amount) === false && isNaN(EtherCoinCommission) === false && isNaN(StandCoinCommission) === false) {
                        if (window.confirm(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_06) === true) {//업그레이드 하시겠습니까?
                            privatePost({ api: getsendTokenUserapi, data: CoinTrnasferData }, (err, response) => {
                                if (err) {
                                    // console.log(err);
                                    if (err.errorCode === 501) {
                                        // console.log("2");
                                        return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
                                    }
                                    else {
                                        return alert(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02);//취소되었습니다
                                    }
                                } else {
                                    // console.log(response?.data?.result);
                                    this.rootStore.CoinStore.setSandCoinData(response?.data?.result);
                                    this.rootStore.CoinStore.setWalletUpdateStart(true);
                                    this.UserMissionLevelUpgrade(value);
                                    // window.location.href = 'https://www.earn-clover.com/';//전송 완료 후 창 이동
                                    // return
                                }
                            });
                        }
                        else {//취소
                            return alert(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02);//취소되었습니다
                        }
                    }
                }
                else {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_clover_005);//코인이 부족합니다
                }
            }
            else {
                return alert(this.rootStore?.loginStore?.ErrorGuide_clover_010);//이더리움이 부족합니다
            }
        }
        else {
            // console.log("1");
            return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
        }



    }

    /** 미션 업그레이트 함수
     * @param {number} pmg_mission_level 팡팡미션레벨
     * @param {number} cag_mission_level 큐브미션레벨
    //  * @param {number} golf_mission_level 골프미션레벨  // 골프
     * @param {number} member_no 멤버넘버
     * @param {number} business_grade business_grade
     */
    UserMissionLevelUpgrade(UpgradeGame) {
        // console.log("UserMissionLevelUpgrade", UpgradeGame);
        let MissionUpgradeGame = UpgradeGame;
        let PmgData;
        let PmgUpdateData;
        let CagData;
        let CagUpdateData;
        let GolfData; // 골프
        let GolfUpdateData; // 골프
        if (this.PmgMissionLevelInfo.length === 2) {
            PmgData = this.PmgMissionLevelInfo[0];
            PmgUpdateData = this.PmgMissionLevelInfo[1];
        }
        else {
            PmgData = this.PmgMissionLevelInfo[0];
        }
        if (this.CagMissionLevelInfo.length === 2) {
            CagData = this.CagMissionLevelInfo[0];
            CagUpdateData = this.CagMissionLevelInfo[1];
        }
        else {
            CagData = this.CagMissionLevelInfo[0];
        }
        if (this.GolfMissionLevelInfo.length === 2) { //골프
            GolfData = this.GolfMissionLevelInfo[0];
            GolfUpdateData = this.GolfMissionLevelInfo[1];
        }
        else {
            GolfData = this.GolfMissionLevelInfo[0];
        }
        let Data;



        if (this.isPmgMaxLevel === true && this.isCagMaxLevel === true && this.isGolfMaxLevel === true) { // 골프
            return alert(this.rootStore?.loginStore?.ErrorGuide_clover_002);//최종레벨에 도달 하셨습니다
        }
        // if (this.isPmgMaxLevel === true && this.isCagMaxLevel === true) { //기존
        //     return alert(this.rootStore?.loginStore?.ErrorGuide_clover_002);//최종레벨에 도달 하셨습니다
        // }
        else {
            if (MissionUpgradeGame === 'pmg') {
                if (this.isPmgMaxLevel === true) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_clover_003);//팡팡 최종레벨에 도달하셨습니다
                }
                else {
                    Data = {
                        member_no: parseInt(this.MissionLevelState.member_no),
                        business_grade: parseInt(this.MissionLevelState.business_grade),
                        pmg_mission_level: parseInt(PmgUpdateData.mission_level),
                        cag_mission_level: parseInt(CagData.mission_level),
                        golf_mission_level: parseInt(GolfData.mission_level),// 골프꺼 올리면 주석 처리 철회
                        game: String(MissionUpgradeGame),
                        // amount: Math.round(PmgData.amount_count)
                    }
                }
            }
            else if (MissionUpgradeGame === 'cag') {
                if (this.isCagMaxLevel === true) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_clover_004);//큐브 최종레벨에 도달하셨습니다
                }
                else {
                    Data = {
                        member_no: parseInt(this.MissionLevelState.member_no),
                        business_grade: parseInt(this.MissionLevelState.business_grade),
                        cag_mission_level: parseInt(CagUpdateData.mission_level),
                        pmg_mission_level: parseInt(PmgData.mission_level),
                        golf_mission_level: parseInt(GolfData.mission_level),// 골프꺼 올리면 주석 처리 철회
                        game: String(MissionUpgradeGame),
                        // amount: Math.round(CagData.amount_count)
                    }
                }
            }
            else if (MissionUpgradeGame === 'golf') {// 골프꺼 올리면 주석 처리 철회
                if (this.isGolfMaxLevel === true) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_clover_020);//큐브 최종레벨에 도달하셨습니다 바꿔야댐!
                }
                else {
                    Data = {
                        member_no: parseInt(this.MissionLevelState.member_no),
                        business_grade: parseInt(this.MissionLevelState.business_grade),
                        cag_mission_level: parseInt(CagData.mission_level),
                        pmg_mission_level: parseInt(PmgData.mission_level),
                        golf_mission_level: parseInt(GolfUpdateData.mission_level),
                        game: String(MissionUpgradeGame),
                        amount: Math.round(GolfData.amount_count)
                    }
                }
            }
        }

        const api = '/userMissionGameLevelUpgrade';


        // Data = {
        //     member_no: parseInt(this.MissionLevelState.member_no),
        //     business_grade: parseInt(this.MissionLevelState.business_grade),
        //     cag_mission_level: parseInt(0),
        //     pmg_mission_level: parseInt(0),
        //     game: String(MissionUpgradeGame),
        //     amount: parseInt(0)
        // }

        // console.log("Update_MissionLevelData",Data);


        if (Data) {
            privatePost({ api: api, data: Data }, (err, response) => {
                if (err) {
                    // console.log(err);
                    if (err.errorCode === 501) {
                        return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시 후 다시 시도해주세요
                    }
                    // this.setUserMissionLevelUpgrade(ErrorData);
                }
                else {
                    this.getUserMissionLevelInfo("OPEN", "Amount");
                    this.getUserMissionCount();
                }
            });
        }
        ;
    };

    setUserMissionLevelUpgrade(data) {
        // console.log(data);
    }


    setMissionError(value) {
        this.ErrorMissionGtade_01 = value;
    }


}